module.exports = __webpack_public_path__ + "static/media/5.478cf574.jpg";